import * as React from 'react';
import { useParams } from 'react-router-dom';
import AtlastkitBreadcrumbs, { BreadcrumbsItem as AtlaskitBreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { ENABLE_DESIGN_ITERATION_1 } from '@css-xp/ppc-constants';
import { useFeatureToggle } from '../../hooks/src/use-feature-toggle';

import BreadcrumbItem from './breadcrumb-item';

export interface Props {
  items: BreadcrumbItem[];
  replaceUrlParams?: boolean;
}
export interface BreadcrumbItem {
  title: string;
  href: string | undefined;
}

export const replaceParamsValuesInUrl = (allParams: Record<string, any>, href?: string): string => {
  if (!href) {
    return '';
  }

  return Object.keys(allParams).reduce((acc, key) => acc.replace(`:${key}`, allParams[key]), href);
};

export default function Breadcrumbs(props: Props) {
  const { items, replaceUrlParams = true } = props;
  const [isEnabled] = useFeatureToggle();
  const isDesignIteration1Enabled = isEnabled(ENABLE_DESIGN_ITERATION_1);
  const allParams = useParams<Record<string, any>>();

  if (isDesignIteration1Enabled) {
    return (
      <AtlastkitBreadcrumbs testId="atlaskit-breadcrumbs" aria-label="Breadcrumbs">
        {items.map((item) => (
          <AtlaskitBreadcrumbsItem
            component={BreadcrumbItem}
            key={item.href}
            text={item.title}
            href={replaceUrlParams ? replaceParamsValuesInUrl(allParams, item.href) : item.href}
          />
        ))}
      </AtlastkitBreadcrumbs>
    );
  }

  return (
    <div className="breadcrumb" data-testid="breadcrumbs">
      {items
        .map((item) => <BreadcrumbItem key={item.href} {...item} />)
        .reduce(
          /*// @ts-ignore */
          (previousBreadcrumbItems, currentBreadcrumbItem, index) => {
            return index !== 0 ? [...previousBreadcrumbItems, ' / ', currentBreadcrumbItem] : [currentBreadcrumbItem];
          },
          []
        )}
    </div>
  );
}
